import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalGeneratedDocumentRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.GENERATED_DOCUMENTS);
  }

  async listByVesselId(vesselId) {
    const documents = await this.table.where("vesselId").equals(vesselId).toArray();
    return documents.sort((left, right) => right.generatedAt.localeCompare(left.generatedAt));
  }

  async listByVoyageId(voyageId) {
    const documents = await this.table.where("voyageId").equals(voyageId).toArray();
    return documents.sort((left, right) => right.generatedAt.localeCompare(left.generatedAt));
  }

  async deleteByVesselId(vesselId) {
    const documents = await this.table.where("vesselId").equals(vesselId).toArray();
    await this.table.bulkDelete(documents.map((document) => document.id));
  }

  async applyRetention({ vesselId, maximumRecords, deleteBefore }) {
    const documents = await this.listByVesselId(vesselId);
    const expired = documents.filter((document) => document.generatedAt < deleteBefore);
    const retained = documents.filter((document) => document.generatedAt >= deleteBefore);
    const overflow = retained.slice(maximumRecords);
    const ids = [...expired, ...overflow].map((document) => document.id);
    if (ids.length > 0) await this.table.bulkDelete(ids);
    return ids.length;
  }
}
